export default {
  boxLength: 400,
  boxHeight: 500,
  boxWidth: 200,
};
